import { StaticJsonRpcProvider } from '@ethersproject/providers'

export const BSC_PROD_NODE = process.env.NEXT_PUBLIC_NODE_PRODUCTION || "https://rpc.ankr.com/eth_sepolia/8336fad58473dbbe5677d919d9a4254db1ee223ef8ec5bf4f891360832de8a46"

export const bscRpcProvider = new StaticJsonRpcProvider(BSC_PROD_NODE)

export default null
